export const STORAGE_KEYS = {
  CHECK_EMAIL: 'check_email',
  FORGOT_PASSWORD_EMAIL: 'forgot_password_email',
  OTP: 'otp',
  RESEND_COUNTDOWN_KEY: 'resend_countdown_key',
  SHOW_PROFILE_SCREEN: 'show_profile_screen',
  TEAM_NAME: 'team_name',
  Team: 'team',
  TOKEN: 'access_token',
  USER: 'user',
  Team_Member_Role: 'teamMemberRole',
  SELECTED_CHAT: 'selected_chat',
  SELECTED_USER: 'selected_user',
  ADDING_TEAM: 'adding_team',
  KEEP_MAIL: 'keep_mail',
  CUSTOM_FIELDS_RESPONSE: 'custom_fields_response',
  USER_TEAM_DATA: 'user_team',
  OTP_TOKEN: 'otp_token',
  CURRENT_SCREEN: 'current_screen',
  IMPERSONATION_TOKEN: 'impersonation_token',
  // Main-platform JWT used to authenticate the separate file service
  SERVICE_TOKEN: 'service_token',
} as const
